import type { DataTableColumn } from '@/components/custom/erp';
import type { DichVu } from '@/types/schemas';

export const getDataTableColumns = (handleViewClick: (obj: DichVu) => void): DataTableColumn<DichVu>[] => {
  return [
    {
      field: 'ma_dv',
      headerName: 'Mã dịch vụ',
      width: 150,
      renderCell: params => {
        return (
          <button
            onClick={e => {
              e.stopPropagation();
              handleViewClick(params.row);
            }}
            className='text-center hover:text-blue-500 hover:underline'
          >
            {params.row.ma_dv}
          </button>
        );
      }
    },
    {
      field: 'ten_dv',
      headerName: 'Tên dịch vụ',
      width: 200,
      flex: 1,
      editable: false
    },
    {
      field: 'dvt_name',
      headerName: 'ĐVT',
      width: 100,
      editable: false
    },
    {
      field: 'tk_dt_name',
      headerName: 'Tài khoản doanh thu',
      width: 150,
      editable: false
    },
    {
      field: 'tk_cp_name',
      headerName: 'Tài khoản chi phí',
      width: 150,
      editable: false
    },
    {
      field: 'ma_thue_name',
      headerName: 'Mã thuế',
      width: 150,
      editable: false
    },
    {
      field: 'gia_nt2',
      headerName: 'Giá bán',
      width: 120,
      editable: false,
      type: 'number'
    },
    {
      field: 'gia_nt',
      headerName: 'Giá mua',
      width: 120,
      editable: false,
      type: 'number'
    }
  ];
};
